import { Timestamp, timestampDate } from '@bufbuild/protobuf/wkt';

import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';

dayjs.extend(isToday);
dayjs.extend(isYesterday);

export function formatTimestamp(
  timestamp?: Timestamp,
  { includeTime = true, includeMilliseconds = false } = {},
) {
  if (!timestamp) return '';

  const date = timestampDate(timestamp);

  let formatString = 'YYYY-MM-DD';

  if (includeTime) formatString += ' HH:mm:ss';

  if (includeMilliseconds) formatString += '.SSS';

  return dayjs(date).format(formatString);
}

export function formatTimestampRelative(
  timestamp?: Timestamp,
  { includeTime = true, includeMilliseconds = false } = {},
) {
  if (!timestamp) return '';

  const date = dayjs(timestampDate(timestamp));

  let timeFormat = '';
  if (includeTime) timeFormat += ' HH:mm';
  if (includeMilliseconds) timeFormat += '.SSS';

  if (date.isToday()) {
    return `Today${includeTime ? ',' : ''}${date.format(timeFormat)}`;
  }

  if (date.isYesterday()) {
    return `Yesterday${includeTime ? ',' : ''}${date.format(timeFormat)}`;
  }

  return date.format(
    `DD-MM-YYYY${includeTime || includeMilliseconds ? ',' : ''}${timeFormat}`,
  );
}
